import { createContext, useContext } from 'react';
import { ApiClient } from '../types';

export const ApiConsumerClientContext = createContext<ApiClient>(undefined!);

export function useApiConsumerClient() {
  return useContext(ApiConsumerClientContext);
}
